<div class="sidebar">
  <app-sidebar-item
    class="rounded hover:bg-hover"
    *dndNestedFor="
      let item of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let expanded = expanded;
      stateKey: 'settings-sidebar';
      dropDisabled: true
    "
    [title]="item.title"
    [icon]="item.icon"
    [depth]="depth"
    [expandable]="expandable"
    [expanded]="expanded.value"
    [active]="currentItemId === item.id || currentContainerId === item.id"
    (onExpand)="expanded.next($event)"
    (appClick)="selectFilter(item)"
    [iconSlot]="depth === 0 ? 'icon' : 'reserved'"
  />
</div>
